import { AxiosResponse } from "axios";
import { SERVER_URL } from "../config";
import { APIClient } from "./apiHelper";
import {
  GetAllArticlesResponse,
  GetAllCommentsResponse,
  GetAllPostsResponse,
  JumpInResponse,
  PostDataInterface,
  UserLoginResponse,
} from "./backendResponseInterfaces";

const apiClient = new APIClient();

// auth
export const getGoogleAuthLoginURL = (
  provider: string,
): Promise<AxiosResponse<JumpInResponse>> =>
  apiClient.get(`${SERVER_URL}/user/login/${provider}`);

export const getPostJumpInToken = (
  provider: string,
  code: string,
): Promise<AxiosResponse<UserLoginResponse>> =>
  apiClient.get(`${SERVER_URL}/user/auth/${provider}?code=${code}`);

// posts
export const getAllPosts = (
  params: any,
): Promise<AxiosResponse<GetAllPostsResponse>> =>
  apiClient.get(`${SERVER_URL}/post/all/`, params);
export const getSinglePost = (
  post_id: string | number,
): Promise<AxiosResponse<PostDataInterface>> =>
  apiClient.get(`${SERVER_URL}/post/${post_id}`);
export const createPost = (data: any): Promise<AxiosResponse<any>> =>
  apiClient.post(`${SERVER_URL}/post/`, data);
export const getTradePostOptions = (): Promise<AxiosResponse<any>> =>
  apiClient.get(`${SERVER_URL}/post/trade_post_options/`);
export const getPostEncodedID = (postId: number): Promise<AxiosResponse<any>> =>
  apiClient.get(`${SERVER_URL}/post/share/${postId}`);

// files
export const getFile = (params: any): Promise<AxiosResponse<any>> =>
  apiClient.get(`${SERVER_URL}/post/file/get/`, params);

export const getFileURL = (fileId: number): string =>
  `${SERVER_URL}/post/file/get?file_id=${fileId}`;

export const uploadFiles = (
  postId: number,
  data: any,
): Promise<AxiosResponse<any>> =>
  apiClient.postForFiles(`${SERVER_URL}/post/upload/${postId}`, data);

// compliments
export const complimentPost = (data: any): Promise<AxiosResponse<any>> =>
  apiClient.post(`${SERVER_URL}/post/like`, data);

// comments
export const getAllComments = (
  postId: number,
  params: any,
): Promise<AxiosResponse<GetAllCommentsResponse>> =>
  apiClient.get(`${SERVER_URL}/post/comments/${postId}`, params);
export const getOneComment = (
  commentId: number,
): Promise<AxiosResponse<GetAllCommentsResponse>> =>
  apiClient.get(`${SERVER_URL}/post/comments/id/${commentId}`);
export const createComment = (data: any): Promise<AxiosResponse<any>> =>
  apiClient.post(`${SERVER_URL}/post/comment`, data);

// news articles
export const getNewsArticles = (
  params: any,
): Promise<AxiosResponse<GetAllArticlesResponse>> =>
  apiClient.get(`${SERVER_URL}/article/`, params);

export { apiClient }; // Optionally export apiClient if needed elsewhere
